(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('Campus', Campus);

    Campus.$inject = ['$resource'];

    function Campus ($resource) {
        var resourceUrl =  'api/campuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
